module.exports = __webpack_public_path__ + "static/media/roundish-chair-naoto-fukusawa.962a6a62.png";